var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { formatDate, normaliseCaps } from './Utils';
var updateContents = function (contents) {
    for (var _i = 0, _a = Object.entries(contents); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        // remove or format some content
        switch (key) {
            case "history":
                delete contents[key];
                break;
            case "last_modified_at":
            case "created_at":
                contents[key] = formatDate(value);
                break;
        }
        // make nulls show a faded 'None'
        if (!value) {
            contents[key] = _jsx("span", __assign({ className: "tooltip-value-none" }, { children: "None" }));
        }
    }
    return contents;
};
function FormatTooltip(props) {
    return (_jsx("div", __assign({ className: 'tooltip-contents' }, { children: Object.entries(updateContents(props.contents)).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (_jsxs("div", __assign({ className: 'formatted-tooltip' }, { children: [_jsxs("span", __assign({ className: 'tooltip-key' }, { children: [normaliseCaps(key), ":"] })), _jsx("span", __assign({ className: 'tooltip-value' }, { children: value }))] }), key));
        }) })));
}
export default FormatTooltip;
